import React from 'react'
import { Typography, Box, Stack, useMediaQuery } from '@mui/material'
import logo from '../images/logo-saladillo.svg'
import logoDark from '../images/logo-saladillo-dark.png'
import backgroundWhiteImage from '../images/background-white-lines-pattern.png'
import backgroundBlackImage from '../images/background-darkmode-lines-pattern.png'
import loginImage from '../images/login-page.jpg'
import { PageOptions } from '../Layout/NavMenu'
import { useThemeContext } from '../../theme/ThemeContext'

type ISCardProps = {
  children?: React.ReactNode
};

const ISCard: React.FC<ISCardProps> = ({ children }) => {
  const { darkModeEnabled } = useThemeContext()
  const isSmallScreen: boolean = useMediaQuery('(max-width:1000px)');
  const isMediumScreen: boolean = useMediaQuery('(max-width:1150px)');

  return (
      <Stack sx={{ //padding: "40px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: darkModeEnabled ? `url(${backgroundBlackImage})` : `url(${backgroundWhiteImage})`,
        display: "flex",
        justifyContent: "space-evenly",
        flexDirection: "row",
        height: "100%",
        textAlign: "justify",   
        alignItems: "stretch"
        } }>
        <Stack component="div" 
            sx={{ display: "flex",
                  margin: "30px",
                  padding: "30px",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderRadius: "10px"}}>
          { isSmallScreen && <PageOptions/> }
          <Typography align="center" variant="h4">
            <img alt={process.env.REACT_APP_NOT_SHOW_LOGO ? "":"Industrias Saladillo"} src={process.env.REACT_APP_NOT_SHOW_LOGO ? "" : darkModeEnabled ? logoDark: logo} />
          </Typography>
          <Stack sx={{display:"flex", flexDirection:"column", alignItems: "center", textAlign: "center", justifyContent:"space-around"}}>
            {children}
          </Stack>
        </Stack>
        { !isMediumScreen && <Stack component="div" 
            sx={{ display: "flex",
                  margin: "30px",
                  padding: "30px",
                  justifyContent: "space-around",
                  alignItems: "center"}}/> }
        { !isSmallScreen && 
          <Box component="div" 
            sx={{ display: "flex",
                  margin: "10px",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  borderRadius: "10px",              
                  }}>
          <PageOptions />
            <Box component="div" 
              sx={{ display: "flex",                 
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundImage: process.env.REACT_APP_NOT_SHOW_LOGO ? '' : `url(${loginImage})`,
                    margin: "30px", 
                    borderRadius: "16px",
                    height: "100%",
                    minWidth: "750px"
                  }}>
            </Box>
        </Box>}
      </Stack>
  )
}
//<img style={{margin: "30px", borderRadius: "16px", maxHeight:"750px"}}  alt="planta I.S." src={loginImage}></img>
export default ISCard;
